import React, { Fragment, useCallback } from "react";
import {
  List,
  Datagrid,
  TextField,
  EditButton,
  Filter,
  TextInput,
  TopToolbar,
  CreateButton,
} from "react-admin";
import { Route, useHistory } from "react-router-dom";
import { Drawer } from "@material-ui/core";

import RiskLevelCreate from "./RiskLevelCreate";
import RiskLevelEdit from "./RiskLevelEdit";

import { Roles } from "../../utils/enums";
import { FormGeneral } from "../../styles/FormGeneral";

const Filters = (props) => (
  <Filter {...props} variant="outlined">
    <TextInput source="name" alwaysOn resettable />
  </Filter>
);

const Actions = ({ permissions, basePath }) => (
  <TopToolbar>
    {permissions === Roles.admin && <CreateButton basePath={basePath} />}
  </TopToolbar>
);

const RiskLevelList = ({ permissions, ...props }) => {
  const classes = FormGeneral();
  const history = useHistory();

  const handleClose = useCallback(() => {
    history.push("/risk-levels");
  }, [history]);

  return (
    <Fragment>
      <List
        filters={<Filters />}
        bulkActionButtons={permissions === Roles.admin ? undefined : false}
        sort={{ field: "id", order: "DESC" }}
        actions={<Actions permissions={permissions} />}
        perPage={25}
        {...props}
      >
        <Datagrid>
          <TextField source="id" />
          <TextField source="name" />
          {permissions === Roles.admin && <EditButton />}
        </Datagrid>
      </List>
      {permissions === Roles.admin && (
        <Route path="/risk-levels/create">
          {({ match }) => (
            <Drawer open={!!match} anchor="right" onClose={handleClose}>
              <RiskLevelCreate
                className={classes.drawerContent}
                onCancel={handleClose}
                {...props}
              />
            </Drawer>
          )}
        </Route>
      )}
      {permissions === Roles.admin && (
        <Route path="/risk-levels/:id">
          {({ match }) => {
            const isMatch = !!(
              match &&
              match.params &&
              match.params.id !== "create"
            );

            return (
              <Drawer open={isMatch} anchor="right" onClose={handleClose}>
                {isMatch ? (
                  <RiskLevelEdit
                    className={classes.drawerContent}
                    id={match.params.id}
                    onCancel={handleClose}
                    {...props}
                  />
                ) : (
                  <div className={classes.drawerContent} />
                )}
              </Drawer>
            );
          }}
        </Route>
      )}
    </Fragment>
  );
};

export default RiskLevelList;
